export const minibatchScheme = {
  additionalProperties: false,
  type: 'object',
  required: ['boxes', 'erp_batch_code'],
  properties: {
    boxes: {oneOf: [{type: 'string'}, {type: 'number'}]},
    erp_batch_code: {type: 'string'},
  },
};
